import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/// <reference types="cordova-plugin-ionic-keyboard">

@Injectable({
  providedIn: 'root'
})
export class WindowObservablesService implements OnDestroy {
  private initializedBS = new BehaviorSubject({ w: window.innerWidth, h: window.innerHeight });
  private sub;
  constructor() {
    this.sub = fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      if ((window as any).Keyboard) {
        if ((window as any).Keyboard.isVisible) {
          return;
        }
      }

      this.initializedBS.next({ w: window.innerWidth, h: window.innerHeight });
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  get windowSize() {
    return this.initializedBS.asObservable();
  }
}
